import React from 'react';
import Header from '../login/Header'; // ログインページのヘッダーを再利用
import Password from './Password';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';
import { useTitle } from '../../hooks/useTitle';

const PasswordReset = () => {
  useTitle('Ton Bébé | パスワードリセット');

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="login">
          <h1 className="sec_title">パスワードリセット</h1>
          <div className="border_box">
            <Password />
            <section>
              <p>ログイン画面は<Link to="/login">こちら</Link></p>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PasswordReset;
